import { Briefcase, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const CARDS = [
  { key: 'total', title: 'Total Jobs', icon: Briefcase, to: '/jobs' },
  { key: 'inProgress', title: 'In Progress', icon: Clock, to: '/jobs?status=active' },
  { key: 'actionRequired', title: 'Action Required', icon: AlertCircle, to: '/jobs?status=review', warn: true },
  { key: 'completed', title: 'Completed', icon: CheckCircle, to: '/history' },
];

/** Compact job counters shown beside the page title: a small round icon, the count and a label. */
const StatCards = ({ summary, loading, onNavigate }) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="job-stats">
    {CARDS.map(({ key, title, icon: Icon, to, warn }) => {
      const highlight = warn && summary[key] > 0;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onNavigate(to)}
          className="inline-flex items-center gap-2 bg-card border border-border rounded-full pl-1.5 pr-3.5 py-1.5 hover:border-foreground transition-colors"
          data-testid={`stat-${key}`}
        >
          <span className={`flex items-center justify-center w-7 h-7 rounded-full ${highlight ? 'bg-warning text-white' : 'bg-muted text-foreground'}`}>
            <Icon className="w-3.5 h-3.5" />
          </span>
          <span className="font-mono text-sm font-medium leading-none">
            {loading ? <Skeleton className="h-4 w-4" /> : summary[key]}
          </span>
          <span className="text-xs text-muted-foreground leading-none">{title}</span>
        </button>
      );
    })}
  </div>
);

export default StatCards;
